// Document types, a customer journey setting (slice 2, doc 13 §4). Children of
// the documentTypeHomes route in administrationModuleRoutes. No meta.section:
// that would switch on the legacy maker-checker header.
const documentTypeRoutes = [
    {
        name: "documentTypeHome",
        path: "",
        component: () => import("./ListDocumentTypes.vue"),
        meta: {
            auth: true,
            title: "Document Types",
            breadcrumb: "Document Types",
            permission: ["view documenttype", "create documenttype", "update documenttype", "delete documenttype"],
        },
    },
];

export default documentTypeRoutes;
